'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.runSaga = exports.initStore = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _redux = require('redux');

var _reduxLogger = require('redux-logger');

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _UiReducer = require('../components/ui/UiReducer');

var _UiReducer2 = _interopRequireDefault(_UiReducer);

var _ModuleReducer = require('../components/module/ModuleReducer');

var _ModuleReducer2 = _interopRequireDefault(_ModuleReducer);

var _DialogReducer = require('../components/dialog/DialogReducer');

var _DialogReducer2 = _interopRequireDefault(_DialogReducer);

var _MaskReducer = require('../components/mask/MaskReducer');

var _MaskReducer2 = _interopRequireDefault(_MaskReducer);

var _ScreenReducer = require('../components/screen/ScreenReducer');

var _ScreenReducer2 = _interopRequireDefault(_ScreenReducer);

var _reduxSaga = require('redux-saga');

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _reduxOidc = require('redux-oidc');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = void 0;

var initStore = exports.initStore = function initStore() {
  // Note: passing middleware as the last argument to createStore requires redux@>=3.1.0
  var sagaMiddleware = (0, _reduxSaga2.default)();

  // do not include logger for tests
  /*istanbul ignore next*/
  var middleware = process.env.NODE_ENV === 'test' ? (0, _redux.applyMiddleware)(sagaMiddleware) : (0, _redux.applyMiddleware)(sagaMiddleware, (0, _reduxLogger2.default)());

  var reducers = (0, _redux.combineReducers)({ oidc: _reduxOidc.immutableReducer, ui: _UiReducer2.default, module: _ModuleReducer2.default, dialog: _DialogReducer2.default, mask: _MaskReducer2.default, screen: _ScreenReducer2.default });

  store = (0, _assign2.default)({}, (0, _redux.createStore)(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), middleware), {
    runSaga: sagaMiddleware.run
  });
};

var runSaga = exports.runSaga = function runSaga() {
  var _store;

  if (!store) {
    return;
  }
  return (_store = store).runSaga.apply(_store, arguments);
};

var getStore = function getStore() {
  if (!store) {
    initStore();
  }

  return store;
};

exports.default = getStore;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/Store.js
// module id = 26
// module chunks = 10